export default "__VITE_ASSET__DDD7x7qi__"